import { css } from "lit";

export const style = css`
	:host {
		display: flex;
		position: relative;
		flex-direction: column;
		height: 100%;
	}

	* {
		box-sizing: border-box;
	}

	.controls {
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		align-items: center;
		flex: 0 0 30.5px;
		border-bottom: 1px solid var(--og-bucket-border-color);
	}

	.controls > og-button {
		min-width: 30px;
	}

	.body {
		flex: 1;
		overflow: hidden;
	}

	og-accordion {
		height: 100%;
		border-top: none;
	}
`;

export const itemStyle = css`
	.item {
		border-bottom: 1px solid var(--og-bucket-border-color);
		line-height: normal !important;
	}

	.parameter-line-1, .parameter-line-2 {
		padding: 0 4px;
		height: 20px;
	}

	.parameter-line-1 {
		display: flex;
		flex-direction: row;
	}

	.parameter-def {
		flex: 1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.parameter-def.has-description {
		font-weight: bold;
	}

	.parameter-menu {
		flex: 0;
		text-align: center;
	}

	rp-custom-parameter {
		height: 20px;
	}

`;
